module.exports = __webpack_public_path__ + "img/cases-brand-yincheng-lazyload-21.6b3444e7.jpg";